/* Veer free-shipping bar sync (R4, 2026-07-03).
   Keeps every [data-veer-freeship] bar (cart page + notification toast) live after any cart
   mutation. Reads /cart.js once per update. THRESHOLD must match veer-free-ship.liquid (250 RON). */
(function () {
  var THRESHOLD = 25000; // cents
  var refreshSeq = 0; // L2 fix #1: guard against out-of-order /cart.js responses
  function fmt(cents) {
    return (cents / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' lei';
  }
  function apply(cart) {
    var total = cart.total_price || 0;
    var empty = !cart.item_count; // L2 fix #2: don't force placeholder bars visible on empty cart
    var rem = THRESHOLD - total;
    var pct = Math.min(100, Math.round((total * 100) / THRESHOLD));
    document.querySelectorAll('[data-veer-freeship]').forEach(function (el) {
      if (empty) { el.hidden = true; return; }
      var reached = rem <= 0;
      el.classList.toggle('veer-freeship--reached', reached);
      el.hidden = false;
      var msg = el.querySelector('.veer-freeship__msg');
      var fill = el.querySelector('.veer-freeship__fill');
      if (msg) msg.innerHTML = reached
        ? 'Felicitări — ai <b>transport gratuit</b>'
        : 'Mai ai <b>' + fmt(rem) + '</b> până la <b>transport gratuit</b>';
      if (fill) fill.style.width = pct + '%';
    });
  }
  function refresh() {
    var seq = ++refreshSeq;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (seq === refreshSeq) apply(c); })
      .catch(function () {});
  }
  document.addEventListener('DOMContentLoaded', function () {
    // Dawn declares `subscribe` / `PUB_SUB_EVENTS` as top-level const → they are lexical globals,
    // NOT properties of window. Reference them directly, guarded by typeof.
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
      }
    } catch (e) {}
  });
})();
